import type { EventTracking } from '../types';
import { getOrderPlatformFromPath } from '../utils/getOrderPlatformFromPath';

export function trackAccountPage(pathname: string | null, eventData: EventTracking) {
    switch (pathname) {
        case '/sign-in':
        case '/create-account': {
            return {
                ...eventData,
                pageName: 'ps:myaccount_login',
                platform: 'commercetools',
                section: 'Login',
                subSection: 'null',
            };
        }
        case '/treats-rewards':
        case '/treats-rewards/authenticated':
        case '/treats-rewards/authenticated/points-history':
        case '/treats-rewards/authenticated/how-it-works':
        case '/treats-rewards/authenticated/events':
        case '/treats-rewards/authenticated/offers': {
            return {
                ...eventData,
                pageName: 'ps',
                section: 'treats rewards',
                subSection: null,
            };
        }
        case '/account/about-you': {
            return {
                ...eventData,
                pageName: 'ps:Account Management About You',
                platform: 'commercetools',
                section: 'My Account',
                subSection: 'edit-profile',
            };
        }
        case '/account/order-history': {
            return {
                ...eventData,
                pageName: 'ps:Account Management No Order History',
                platform: 'commercetools',
                section: 'My Account',
                subSection: 'order-history',
            };
        }
        case '/account/address-book': {
            return {
                ...eventData,
                pageName: 'ps:Account Management Address Book',
                platform: 'commercetools',
                section: 'My Account',
                subSection: 'address-list',
            };
        }
        case '/account/credit-cards': {
            return {
                ...eventData,
                pageName: 'ps:Account Management Credit Cards',
                platform: 'commercetools',
                section: 'My Account',
                subSection: 'payment-intruments',
            };
        }
        default: {
            if (pathname?.includes('/account/order-details/')) {
                const platform = getOrderPlatformFromPath(pathname);

                return {
                    ...eventData,
                    pageName: 'ps:Account Management No Order History',
                    platform,
                    section: 'My Account',
                    subSection: 'order-details',
                };
            }
            return {
                ...eventData,
                pageName: 'ps',
                platform: 'commercetools',
                section: null,
                subSection: null,
            };
        }
    }
}
